import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import BottomNav from './BottomNav';
import './Layout.css';

const Layout = () => {
  const location = useLocation();
  
  // Pages that don't show header
  const noHeaderPages = ['/'];
  
  // Pages that don't show bottom nav
  const noBottomNavPages = [];
  
  const showHeader = !noHeaderPages.includes(location.pathname);
  const showBottomNav = !noBottomNavPages.includes(location.pathname);

  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className={`main-content ${!showHeader ? 'no-header' : ''} ${!showBottomNav ? 'no-bottom-nav' : ''}`}>
        <Outlet />
      </main>
      {showBottomNav && <BottomNav />}
    </div>
  );
};

export default Layout;
